import { apiService } from "../api";
import { Category } from "../categoryService";

export interface CreateCategoryRequest {
  name: string;
  description?: string | null;
  displayOrder?: number;
  isActive?: boolean;
}

export interface UpdateCategoryRequest {
  name?: string;
  description?: string | null;
  displayOrder?: number;
  isActive?: boolean;
}

export const adminCategoryService = {
  getAll: async (): Promise<Category[]> => {
    return await apiService.get<Category[]>("/admin/categories");
  },

  getById: async (id: string): Promise<Category> => {
    return await apiService.get<Category>(`/admin/categories/${id}`);
  },

  create: async (data: CreateCategoryRequest): Promise<Category> => {
    return await apiService.post<Category>("/admin/categories", data);
  },

  update: async (id: string, data: UpdateCategoryRequest): Promise<Category> => {
    return await apiService.put<Category>(`/admin/categories/${id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    return await apiService.delete(`/admin/categories/${id}`);
  },
};

